
import { useState } from 'react';

/**
 * Hook para gestionar un estado de carga.
 * @param {boolean} [initialState=false] Estado inicial de carga.
 * @returns Objeto que contiene el estado de carga y funciones para iniciar y detener la carga.
*/
export const useLoading = (initialState = false) => {
  const [isLoading, setIsLoading] = useState(initialState);

  const start = () => setIsLoading(true);
  const stop = () => setIsLoading(false);

  return { isLoading, start, stop };
};